//
// Public-facing web bundle — excludes admin-only plugins (Select2, moment,
// Flatpickr, SweetAlert2, DateRangePicker, inputmask, clipboard, GSAP, etc.)
// to keep main-thread parse/compile work low on marketing pages.
//

// jQuery
window.jQuery = window.$ = require('jquery');

// Bootstrap + Popper
window.bootstrap = require('bootstrap');
window.Popper = require('@popperjs/core');

// CSRF token
let token = document.head.querySelector('meta[name="csrf-token"]');
if (token) {
    window._token = token.content;
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}
window.IpixJson = {};
window.IpixJson.lang = {};
window.IpixJson.options = {};

// FormValidation — needed for header enquiry form present on every page
window.FormValidation = require('../../plugins/formvalidation/dist/js/FormValidation.full.min.js');
window.FormValidation.plugins.Bootstrap5 = require('../../plugins/formvalidation/dist/amd/plugins/Bootstrap5.js').default;
require('./plugins/FormValidation.init.js');

// Select2 — needed for product/service dropdowns in the header Let's Talk form
require('select2/dist/js/select2.full.min.js');
require('./plugins/select2.init.js');

// msDropdown — needed for country code selector in the header Let's Talk form
require('../../plugins/msDropdown/js/index.js');
require('./plugins/ms-dropdown.init.js');

// Toastr — lightweight notification library
window.toastr = require('../../plugins/toastr/build/toastr.min.js');
require('./plugins/toastr.init.js');

// OWL Carousel — used on home, products, blogs, services pages
require('owl.carousel2');
require('./plugins/owl.carousel2.init.js');

// Locomotive Scroll — site-wide smooth scroll
require('../../plugins/locomotive/locomotive-scroll.js');

// Smooth Scroll — anchor link scrolling
window.SmoothScroll = require('smooth-scroll/dist/smooth-scroll.js');

// Ipix core components
window.IpixComponents = require('./components/_init.js');
window.IpixUtil = require('./components/util.js');
window.IpixApp = require('./components/web.js');
window.IpixFormValidation = require('./components/formValidation.js');
window.IpixEnquiry = require('./components/enquiry.js');
window.IpixEventHandler = require('./components/event-handler.js');
window.IpixBlockUI = require('./components/blockui.js');
window.IpixCookie = require('./components/cookie.js');
window.IpixDialer = require('./components/dialer.js');
window.IpixDrawer = require('./components/drawer.js');
window.IpixMenu = require('./components/menu.js');
window.IpixForm = require('./components/form.js');
window.IpixModal = require('./components/modal.js');
window.IpixScroll = require('./components/scroll.js');
window.IpixScrolltop = require('./components/scrolltop.js');
window.IpixToggle = require('./components/toggle.js');
